import React from 'react';

class PanelView extends React.Component {
  render() {
    const { expanded } = this.props;

    if (expanded === true) {
      return <div className="treeview-content-panel">{this.props.children}</div>;
    } else {
      return <div />;
    }
  }
}

PanelView.defaultProps = {
  expanded: false,
};

export default PanelView;
